import { FormControl, Input } from '@mui/joy';

import { FormLabel } from 'core/elements';

import { IInputProps } from './Input';

const InputView = ({ label, tooltip, error, required = false, ...rest }: IInputProps) => {
  return (
    <FormControl>
      {label && (
        <FormLabel required={required} tooltip={tooltip}>
          {label}
        </FormLabel>
      )}

      <Input error={Boolean(error)} {...rest} />
    </FormControl>
  );
};

export default InputView;
